import { Reveal } from "./Reveal";

const CARDS = [
  {
    n: "01",
    title: "Seamless Gutter Installation",
    span: "md:col-span-8",
    image:
      "https://images.unsplash.com/photo-1635424824849-1b09bdcc55b1?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "01 / Roof & Eaves Shield",
    desc: "Custom on-site extruded seamless copper and heavy-gauge aluminum rain gutters tailored to your exact roofline dimensions.",
    testid: "service-card-gutters",
  },
  {
    n: "02",
    title: "Gutter Guard Micro-Mesh",
    span: "md:col-span-4",
    image:
      "https://images.unsplash.com/photo-1634853982486-c06f0e17940f?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "02 / Zero Maintenance",
    desc: "Stainless steel mesh blocks leaves, pine needles, and debris permanently.",
    testid: "service-card-guards",
  },
  {
    n: "03",
    title: "Basement Waterproofing & French Drains",
    span: "md:col-span-6",
    image:
      "https://images.unsplash.com/photo-1623955277601-2aa7bb3fb240?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "03 / Sub-Grade Protection",
    desc: "Interior and exterior sub-grade drainage channels, sump pump stations, and vapor barriers that keep basements bone dry.",
    testid: "service-card-waterproofing",
  },
  {
    n: "04",
    title: "Heavy-Flow Downspouts & Extensions",
    span: "md:col-span-6",
    image:
      "https://images.unsplash.com/photo-1524568292009-5c8f3fe5dcc7?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "04 / Water Diversion",
    desc: "High-capacity downspout underground lines channeling water 20+ feet away from foundation walls.",
    testid: "service-card-downspouts",
  },
];

export const Services = () => (
  <section id="services" className="py-20 lg:py-32" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <Reveal>
        <div className="flex items-center gap-4">
          <span className="h-px w-10 bg-orange-500" />
          <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-orange-500">
            What We Build
          </p>
        </div>
        <h2 className="mt-4 max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] text-white sm:text-5xl lg:text-6xl">
          Engineered Systems. <span className="text-outline">Not Patch Jobs.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-12 lg:gap-8">
        {CARDS.map((card, i) => (
          <Reveal key={card.title} delay={i * 0.1} className={`col-span-1 ${card.span}`}>
            <article
              data-testid={card.testid}
              className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-ink2 transition-all duration-300 hover:-translate-y-1.5 hover:border-orange-500/40 hover:shadow-[0_20px_60px_-20px_rgba(249,115,22,0.25)]"
            >
              <div className="relative h-56 overflow-hidden sm:h-64">
                <img
                  src={card.image}
                  alt={card.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink2 via-transparent to-transparent" />
                <span className="absolute left-4 top-4 rounded-full border border-orange-500/40 bg-ink/70 px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-orange-500 backdrop-blur-sm">
                  {card.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6 sm:p-8">
                <h3 className="font-display text-2xl font-bold uppercase text-slate-100 sm:text-3xl">
                  {card.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">
                  {card.desc}
                </p>
                <a
                  href="#quote"
                  className="mt-auto pt-6 text-sm font-bold uppercase tracking-wide text-orange-500 transition-colors hover:text-orange-400"
                  data-testid={`${card.testid}-cta`}
                >
                  Get This Quoted →
                </a>
              </div>
              <span
                className="ghost-numeral pointer-events-none absolute -bottom-6 right-3 font-display text-[7.5rem] font-black leading-none transition-all duration-500 group-hover:-translate-y-2"
                aria-hidden="true"
              >
                {card.n}
              </span>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
